import axios from 'axios';
import {
  showToast
} from 'vant';
import {
  showConfirmDialog
} from 'vant';
import router from '../router';
import store from '../store';
var myData = null;
const ajax = axios.create({
  headers: {
    token: store.state.loginInfo.token || '',
    'Content-Type': 'application/jsEon'
  },
  baseURL: window.baseUrl
  // baseURL: 'http://ttc.com.cn/api'
  // baseURL: 'http://wusenceshi.doing.net.cn/api'
  // baseURL: 'http://ttc1226.com.cn/api'
  // baseURL: 'http://ttc1207.com.cn/api'

})

// 拦截响应
const filterErrorCode = (errCode) => {
  let errMessage = '请稍后再试！'
  switch (Number(errCode)) { 
    case 400:
      errMessage = '请求接口出现问题'
      break
    case 404:
      errMessage = '请求服务不存在'
      break
    case -100:
    case 401:
      // if (!location.hash.includes('login') && router.history.current.meta.isAuth) {
      //   location.replace('/#/login')
      // }

      errMessage = '请重新登录'
      break
    case 405:
      errMessage = '请修改请求方式/无此方法'
      break
    case 500:
      errMessage = '服务器发生错误，请检查服务器'
      break
    case 502:
      errMessage = '网关错误'
      break
  }
  return errCode + ' ' + errMessage
}
// 拦截请求
ajax.interceptors.request.use(config => {
  if (config.myData) {
    myData = {
      ...config.myData
    }
  } else {
    myData = null;
  }
  for (let key in config) {
    if (config[key] === null || config[key] === undefined) {
      delete config[key];
    }
  }
  if (config.noFormData) {
    return config;
  }
  const form = new FormData()
  for (const key in config.data) {
    form.append(key, config.data[key])
  }
  config.data = form
  return config
}, error => {
  // console.log(error)
  return Promise.reject(error)
})

ajax.interceptors.response.use(response => {
  if (response.status !== 200 || response.data.errcode !== 1) {
    if (response.data.errcode == -100) {
      let {
        path
      } = router.currentRoute._value;
      let column_type = 0
      if (path.includes('culture')) {
        column_type = 1
      }
      if (path.includes('vote')) {
        column_type = 2
      }
      if (path.includes('vote')) {
        column_type = 3
      }
      // if(path.includes('???')){ //财政暂时没
      //   column_type = 4
      // }
      if (path.includes('join')) {
        column_type = 5
      }
      if (path.includes('paper')) {
        column_type = 6
      }
      if (path.includes('procure')) {
        column_type = 7
      }
      if (path.includes('forum')) {
        column_type = 8
      }
      if (path.includes('shop')) {
        column_type = 9
      }
      const currentPath = router.currentRoute._value.fullPath

      showConfirmDialog({
          title: '是否登录'
        })
        .then(() => {
          // on confirm
          sessionStorage.setItem('backPath', currentPath)

          router.push({
            path: "/login",
            query: {
              column_type
            }
          })
        })
        .catch(() => {
          // on cancel
          return
        });

    }
    // 修改，仅对response.status进行判断，不对response.data.errcode == 0时进行统一的展示
    // const msg = filterErrorCode(response.data.errcode || response.status);
    const msg = filterErrorCode(response.data.errcode || response.status);
    if (!myData || myData.showMsg == true) {
      let message = response.data.message || msg || '操作失败'
      if (message !== '请登录') {
        showToast({
          message: (message)
        })
      }


    }
    return Promise.reject(response.data)
  } else {
    // 如果设置了myData.showMsg设置为true时弹出成功消息
    if (myData && myData.showMsg == true) {
      showToast({
        type: 'success',
        message: response.data.message
      })
    }
    return response.data;
  }
}, error => {
  showToast({
    message: '请稍后再试'
  })
  return Promise.reject(error)
})

export default ajax;